import {
  BorderButton,
  BorderButton2,
  BorderButton2Circle,
  ColorTitle,
  CommonButton,
  CommonButton2,
  CommonRow,
  CommonTitle,
} from './SideInfoStyle';
import {
  ISButton1Props,
  ISButton1Props2,
  ISButton1Props3,
  ISButton1Props4,
} from './SideInfo';
import { useReportContext } from '../context/DetailContext';
export const SButton1 = (data: ISButton1Props) => {
  const { lng, lat, geom } = useReportContext();
  return (
    <BorderButton
      color={data.color}
      number={data.number}
      link={data.link}
      onClick={() => {
        if (data.link) {
          if (data.link.includes('fullSizeMap')) {
            sessionStorage.setItem('lat', lat.toString());
            sessionStorage.setItem('lng', lng.toString());
            sessionStorage.setItem('geom', JSON.stringify(geom));
            // 새 창 열기
            const newWindow = window.open(data.link);

            // // 새 창이 로드된 후 sessionStorage에서 값 읽기
            // newWindow?.addEventListener('load', () => {
            //   const lat = sessionStorage.getItem('lat');
            //   const lng = sessionStorage.getItem('lng');
            //   // console.log(lat, lng); // 값 확인
            // });
          } else {
            window.open(data.link);
          }
        }
      }}
    >
      {data.icon ? <img src={data.icon} alt="" /> : ''}
      {data.content}
    </BorderButton>
  );
};



export const SButton2 = (data: ISButton1Props2) => {
  return (
    <BorderButton2 style={data.style}>
      {data.icon ? (
        <BorderButton2Circle>
          <img src={data.icon} alt="" />{' '}
        </BorderButton2Circle>
      ) : (
        ''
      )}
      {data.content}
    </BorderButton2>
  );
};

export const SButton3 = (data: ISButton1Props3) => {
  return (
    <CommonButton width={data.width}>
      <ColorTitle color={data.color}>{data.refer}</ColorTitle>
      <CommonRow>
        <CommonTitle>{data.title}</CommonTitle>
        <img src="/assets/images/side/Arrow.svg" alt="" />
      </CommonRow>
    </CommonButton>
  );
};

export const SButton4 = (data: ISButton1Props4) => {
  return (
    <CommonButton2 color={data.color}>
      {data.icon ? <img className="s_button3" src={data.icon} alt="" /> : ''}
      {data.content}
    </CommonButton2>
  );
};